import React from 'react';
import PropTypes from 'prop-types';
import StyledButton from 'common/StyledButton';
import css from './ConfirmAppointment.css'
import moment from 'moment';
import TextHeader from "./TextHeader";
import {getDateFormat} from "../utils/time";
import useStarfishAPI from "../hooks/useStarfishAPI";
import useError from "../hooks/useError";
import {urlParams} from "../utils/request";
import {Card} from "semantic-ui-react";
import KioskImage from "./KioskImage";
import {getPhotoURL} from "../utils/images";

function ConfirmAppointment(props) {

  const [{data, success, error }, callAPI] = useStarfishAPI();

  const onConfirmAppointmentStudent = () => {
    const URL = `../kiosk/signInWaitingRoomStudentConfirm.html`;
      callAPI(URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: urlParams({
          studentId: props.loginId,
          serviceId: props.serviceId,
          kioskId: props.kioskId,
          lastName: props.studentLastName,
          email: props.email
        }, false)
      });
  };

  const onConfirmAppointmentProspect = () => {
    const URL = `../kiosk/signInProspectWalkIn.html`;
    callAPI(URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        studentId: props.studentId,
        kioskId: props.kioskId,
        confirmStudent: true,
        secondaryEmail: props.email,
        serviceId: props.serviceId
      })
    });
  };

  if (success)  {
    if (data && data.waitingRoomStatus) {
      props.onConfirm(data.waitingRoomStatus.waitingRoomQueueId);
    } else {
      props.onConfirm();
    }
  }

  useError(error, props.setError);

  const getHourFromDate = (date) => {
    return moment(date).format(getDateFormat('timeDisplayFormat'));
  };

  return (
    <div>
      <div className={css['content']}>
        <TextHeader
          id="appointmentConfirmationSelection"
          upperText={`Hi, ${props.studentName}!`}
          lowerText={`Are you here for your ${getHourFromDate(props.appointmentStartTime)} appointment with ${props.instructorName}?`}
        />
        <Card.Group className={css['card-group']}>
          <Card className={css['card']} fluid>
            <div className={css['icon']}>
              <KioskImage imageUrl={getPhotoURL(props.instructorUid, true)} size={'G'}/>
            </div>
            <div className={css['text']}>
              <div className={css['first-row']}>{props.instructorName}</div>
              <div className={'second-row'}>{props.instructorTitle}</div>
            </div>
          </Card>
        </Card.Group>
        <div className={css['button-group']} aria-labelledby="appointmentConfirmationSelection">
          <StyledButton
            className={css['primary-button']}
            onClick={() => props.isProspectiveStudent ? onConfirmAppointmentProspect() : onConfirmAppointmentStudent()}>
            Yes, Check In
          </StyledButton>
          {(props.canViewWaitList &&
            <StyledButton
              asLink
              className={css['link-button']}
              onClick={props.goToSelectService}>
              No, I want to join the wait list
            </StyledButton>)}
        </div>
      </div>
    </div>
  );
}

ConfirmAppointment.defaultProps = {
  canViewWaitList: true
};

ConfirmAppointment.propTypes = {
  studentName: PropTypes.string.isRequired,
  appointmentStartTime: PropTypes.string.isRequired,
  instructorName: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  goToSelectService: PropTypes.func.isRequired,
  canViewWaitList: PropTypes.bool.isRequired,
  email: PropTypes.string,
  loginId: PropTypes.string,
  studentLastName: PropTypes.string,
  setError: PropTypes.func.isRequired,
  setWarning: PropTypes.func.isRequired,
  serviceId: PropTypes.number.isRequired,
  kioskId: PropTypes.number.isRequired,
  studentId: PropTypes.number,
  isProspectiveStudent: PropTypes.bool.isRequired,
  instructorUid: PropTypes.string,
  instructorTitle: PropTypes.string
};

export default ConfirmAppointment;
